/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 11/11/2021
 * @Example
 */

export const types = {
    W05F0011_GET_CBO_OBJECTS: 'W05F0011_GET_CBO_OBJECTS',
    W05F0011_GET_CBO_EMPLOYEE: 'W05F0011_GET_CBO_EMPLOYEE',
    W05F0011_GET_CBO_KIND_VOUCHER: 'W05F0011_GET_CBO_KIND_VOUCHER',
    W05F0011_LOAD_FORM: 'W05F0011_LOAD_FORM',
    W05F0011_DELETE: 'W05F0011_DELETE',
    W05F0011_GET_CBO_STATUS: 'W05F0011_GET_CBO_STATUS',
    W05F0011_UPDATE_STATUS: 'W05F0011_UPDATE_STATUS',
}

export function getCboEmployees(params, cb) {
    return {
        type: types.W05F0011_GET_CBO_EMPLOYEE,
        params,
        cb
    }
}

export function getCboObjects(params, cb) {
    return {
        type: types.W05F0011_GET_CBO_OBJECTS,
        params,
        cb
    }
}

export function getCboKindVoucher(params, cb) {
    return {
        type: types.W05F0011_GET_CBO_KIND_VOUCHER,
        params,
        cb
    }
}

export function loadForm(params, cb) {
    return {
        type: types.W05F0011_LOAD_FORM,
        params,
        cb
    }
}

export function onDelete(params, cb) {
    return {
        type: types.W05F0011_DELETE,
        params,
        cb
    }
}

export function getCboStatus(params, cb) {
    return {
        type: types.W05F0011_GET_CBO_STATUS,
        params,
        cb
    }
}

export function onUpdateStatus(params, cb) {
    return {
        type: types.W05F0011_UPDATE_STATUS,
        params,
        cb
    }
}


